import { CustomElementObservedAttributes, CustomElementAttributeMapperFunction } from "@/models/customElements";

export function setCustomElementMetadata(options: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: any,
    tagName: string,
    observedAttributes?: CustomElementObservedAttributes
}) {
    if (!options.component.prototype) options.component.prototype = {};
    options.component.prototype.customElementTag = options.tagName;
    if (options.observedAttributes) {
        options.component.prototype.customElementObservedAttributes = options.observedAttributes;
    }
}

interface ICustomElementAttributeMapper {
    [key: string]: CustomElementAttributeMapperFunction;
}

export const customElementAttributeMappers: ICustomElementAttributeMapper = {
    id: (value: string) => ({ value, prop: 'id' }),
    string: (value: string) => ({ value }),
    boolean: (value: string) => ({ value: value === '' || value === 'true' ? true : false }),
    number: (value: string) => ({ value: value === null || value === undefined || value === '' || isNaN(Number(value)) ? null : Number(value) }),
    json: <T>(value: string) => {
        try {
            return { value: JSON.parse(value) as T };
        } catch (err) {
            console.error(err);
        }
    }
}

export function goToParentPage(...args: (string | null)[]) {
    try {
        (globalThis as unknown as { go: (...args: (string | null)[]) => void; }).go(...args);
    } catch (err) {
        console.error(err);
    }
}

export function goToParentModal(...args: (string | null)[]) {
    try {
        (globalThis as unknown as { goM: (...args: (string | null)[]) => void; }).goM(...args);
    } catch (err) {
        console.error(err);
    }
}